import { AIResponse, AIResponseStateType, AiChatMessage } from 'src/@types/ai';
import create from 'zustand';

const InitialAIResponse: AIResponseStateType = {
  query: '',
  searchSources: [],
  reasoning: '',
  content: '',
  error: null,
  status: null,
  isLoadingSources: true,
  isLoadingThinking: true,
  isReasoningCollapsed: false,
  reasoningTime: {},
  searchTime: 0,
};

interface AIResponseState {
  messages: AiChatMessage[];
  setMessages: (messages: AiChatMessage[]) => void;
  addMessage: (message: AiChatMessage) => void;
  aiResponse: AIResponseStateType;
  updateAIResponse: (update: Partial<AIResponseStateType>) => void;
  getAIMessage: () => AiChatMessage | undefined;
  resetAIResponse: () => void;
}

export const useAIResponseStore = create<AIResponseState>((set, get) => ({
  messages: [],
  setMessages: (messages: AiChatMessage[]) => set({ messages }),
  addMessage: (message: AiChatMessage) =>
    set((state) => ({ messages: [...state.messages, message] })),
  aiResponse: InitialAIResponse,
  updateAIResponse: (update: Partial<AIResponse>) =>
    set((state) => ({
      aiResponse: { ...state.aiResponse, ...update },
      messages: [
        ...state.messages.map((message) =>
          message.status === 'loading' || message.status === 'thinking'
            ? {
                ...message,
                searchResults: update.searchSources || message.searchSources,
                reasoning: update.reasoning || message.reasoning,
                content: update.content || message.content,
                status: update.status === null ? null : message.status,
                reasoningTime: update.reasoningTime || message.reasoningTime,
                searchTime: update.searchTime || message.searchTime,
                error: update.error || message.error,
              }
            : message,
        ),
      ],
    })),
  getAIMessage: () =>
    get().messages.find(
      (message) =>
        message.status === 'loading' || message.status === 'thinking',
    ),
  resetAIResponse: () => set({ aiResponse: InitialAIResponse }),
}));
